import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Team } from '../../../pages/team/Team';
import { getListTeamMembersQueryOptions } from '../../../rest-api/queries/sharedQueries';

export const Route = createFileRoute('/_private/_home/team')({
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(getListTeamMembersQueryOptions(context.apiClient));
  },
  component: TeamRoute,
});

function TeamRoute() {
  const { apiClient } = Route.useRouteContext();
  return <Team portalApiClient={apiClient} />;
}
